module.exports = __webpack_public_path__ + "media/images/details__prizeBox__event__third-dbec16b60e45fc9a9e9379eeb072e340.png";